import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type Template } from '../../api/communication';

export function TemplateBuilderPage() {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [name, setName] = useState('');
  const [channel, setChannel] = useState('email');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState('');

  const load = () => {
    void communicationApi.listTemplates().then((r) => setTemplates(r.templates)).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim() || !body.trim()) return;
    try {
      await communicationApi.createTemplate({ name, channel, subject, body });
      setName(''); setSubject(''); setBody('');
      load();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Template Builder</h1>
      <div className="mt-6 space-y-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Template name"
          className="w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <select value={channel} onChange={(e) => setChannel(e.target.value)}
          className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900">
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="in_app">In-App</option>
        </select>
        <input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject (optional)"
          className="w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="Body with {{variables}}"
          rows={4} className="w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <button onClick={() => void create()}
          className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">
          Create Template
        </button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {templates.map((t) => (
          <li key={t.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{t.name}</span>
              <span className="text-xs text-slate-500">{t.channel} · v{t.version}</span>
            </div>
            {t.subject && <p className="mt-1 text-sm">{t.subject}</p>}
            <p className="mt-1 text-sm text-slate-500 line-clamp-2">{t.body}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
